import type { Channel } from '@/Enums/Channel.enum';
import { GAM_VIDEO_POSITIONS } from '@/constants/forecaster';
import { Checkbox, FormControlLabel, Paper } from '@mui/material';
import { useCallback } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

interface IProps {
  currentChannel: Channel;
}

const GamVideoPosition = ({ currentChannel }: IProps) => {
  const { control, setValue } = useFormContext();
  const field = `${currentChannel}.videoPositions`;
  const selected: string[] = useWatch({ control, name: field }) ?? [];

  const toggle = useCallback(
    (value: string) => {
      const next = selected.includes(value) ? selected.filter(v => v !== value) : [...selected, value];
      setValue(field, next);
    },
    [selected, setValue, field],
  );

  return (
    <Paper className='col-span-3 p-4 print:p-[10px] break-after-page'>
      <div className='flex flex-col gap-2'>
        <p className='text-[#2E2C34] text-[18px] font-semibold'>Video Position</p>
        <div className='flex flex-col'>
          {GAM_VIDEO_POSITIONS.map(({ value, label }) => (
            <FormControlLabel
              key={value}
              sx={{ marginLeft: 0, fontSize: '14px' }}
              control={
                <Checkbox sx={{ padding: '6px' }} checked={selected.includes(value)} onChange={() => toggle(value)} />
              }
              label={label}
            />
          ))}
        </div>
      </div>
    </Paper>
  );
};

export default GamVideoPosition;
